import moment from "moment";
import React, { useState, useEffect, useRef } from "react";

export const Timer = ({ start, isPaused }) => {
  const [timer, setTimer] = useState("00:00:00");
  const elapsedOnPauseRef = useRef(0);
  const resumeStartRef = useRef(start);

  useEffect(() => {
    if (!isPaused) {
      // Set a virtual start that accounts for previously accumulated time
      resumeStartRef.current = moment
        .utc()
        .subtract(elapsedOnPauseRef.current, "ms");

      const interval = setInterval(() => {
        const elapsed = moment.utc().diff(resumeStartRef.current);
        setTimer(moment.utc(elapsed).format("HH:mm:ss"));
      }, 500);

      return () => {
        // Save elapsed time so we can resume from here
        elapsedOnPauseRef.current = moment
          .utc()
          .diff(resumeStartRef.current);
        clearInterval(interval);
      };
    }
  }, [isPaused]);

  return (
    <span
      className={
        "w-32 text-center text-secondary font-medium text-xl rounded-full border-2 border-primary bg-primary p-1"
      }
    >
      {timer}
    </span>
  );
};
